import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-storyboard",
  "use": "icon-storyboard-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-storyboard\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M8.67,9.89A2,2,0,1,1,9.89,7.34h4.22a2,2,0,1,1,0,1.33H12a3.36,3.36,0,0,1,.67,2v2.66a2,2,0,0,0,1.47,1.93,2,2,0,1,1,0,1.36,3.34,3.34,0,0,1-2.77-3.29V10.67A2,2,0,0,0,9.86,8.74,2,2,0,0,1,8.67,9.89Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol